import { API_URLs } from "../../../../utilities/API_URLs";
import { Http } from "../../../../utilities/axios/http";

export class GateInService {
    static getGateInList = async (params?: any) => {
        try {
            return await Http.get(API_URLs.customerRestitutionControl.customerRestitutionControlUrl, params)
        } catch (error) {
            return error;
        }
    }

    static getGateInById = async (id: number) => {
        try {
            return await Http.get(`${API_URLs.customerRestitutionControl.customerRestitutionControlUrl}/${id}`)
        } catch (error) {
            return error;
        }
    }
}